import gql from 'graphql-tag'
import { useRetailersQuery } from 'legacy/apollo/clientHooks'

const FETCH_CURRENT_PARTNER_USER_WAREHOUSES_QUERY = gql`
  query warehouses {
    currentPartnerUser {
      warehouses {
        id
        name
      }
    }
  }
`

interface CurrentPartnerUserWarehouses {
  warehouses: { id: string; name: string }[]
}

interface CurrentPartnerUserWarehousesData {
  currentPartnerUser: CurrentPartnerUserWarehouses
}

export const useFetchWarehouses = () => {
  const { data, loading, error } = useRetailersQuery<CurrentPartnerUserWarehousesData, {}>(
    FETCH_CURRENT_PARTNER_USER_WAREHOUSES_QUERY
  )

  const warehouses = data?.currentPartnerUser?.warehouses

  return {
    warehouses,
    loading,
    error,
  }
}
